import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { MonitoringNotificationsComponent } from './notifications/monitoring-notifications.component';
import { LatestNotificationComponent } from './latest-notification/latest-notification.component';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { StatusHistoryComponent } from './status-history/status-history.component';
import { StatusCodeModule } from '../../status-code/status-code.module';
import { TimezoneModule } from '../../timezone/timezone.module';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { DateWithProfileAndLocalTimezoneModule } from '../../profile-and-local-date/date-with-profile-and-local-timezone.module';

@NgModule({
  imports: [
    IntrackFeatureModule,
    TranslateModule.forChild({}),
    TooltipModule,
    StatusCodeModule,
    TimezoneModule,
    SvgIconModule,
    DateWithProfileAndLocalTimezoneModule,
  ],
  declarations: [MonitoringNotificationsComponent, LatestNotificationComponent, StatusHistoryComponent],
  exports: [MonitoringNotificationsComponent, LatestNotificationComponent, StatusHistoryComponent],
})
export class MonitoringCardDetailsModule {}
